<template>
	<div>
		<shutter-panel ref="shutterPanel" />
	</div>
</template>


<script type="text/javascript">
	import Shutter from "@/mixins/Shutter.js"
	import ShutterInvoice from "@/mixins/shutters-manager/Invoice.js"
	import _cloneDeep from 'lodash/cloneDeep'

	export default {
		name: "InvoiceSupplierFicheControl",
		mixins: [Shutter, ShutterInvoice],
		props: {
			invoice: { type: Object, default: () => ({}) },
			invoicesupplier_id: { type: [String, Number], default: null }
		},

		watch: {
			// La fiche recharge la facture après chaque enregistrement : le formulaire se refait alors
			// sur les données à jour, sans quoi il continuerait d'afficher celles de son ouverture.
			invoice: 'openForm'
		},

		mounted() {
			this.openForm()
		},

		methods: {
			/**
			 * Ouvre le formulaire de contrôle de l'application plutôt que d'en écrire un second : la
			 * recherche de fournisseur, la création de tiers depuis Pappers, les échéances et le
			 * passage en contrôlée y sont déjà traités. L'onglet n'en est que le point d'entrée.
			 *
			 * La facture est copiée : le formulaire convertit ses dates en objets Date et lui ajoute
			 * son propre indicateur de contrôle, ce qui corromprait la copie que porte la fiche.
			 */
			openForm() {
				const shutters = this.getInvoicesShutter({
					invoice_supplier: _cloneDeep(this.invoice)
				})

				this.shutterPanel().open(shutters['invoice-supplier-control-form'])
			},

			/**
			 * Rappelée par le formulaire après enregistrement — le nom est celui qu'attend sa
			 * définition. Le bandeau, l'aperçu et les montants dépendent de ce qui vient d'être saisi.
			 */
			loadInvoicesSupplier() {
				this.$emit('invoice-updated')
			}
		}
	}
</script>
